import {
  loginByUsername,
  logout,
  getUserInfo
} from '@/api/login'

import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const UserKey = 'Admin-User'
const RoleKey = 'Admin-Role'

const user = {
  state: {
    user: JSON.parse(localStorage.getItem(UserKey)),
    token: Cookies.get(TokenKey),
    roles: JSON.parse(localStorage.getItem(RoleKey)),
  },

  mutations: {
    SET_USER: (state, user) => {
      state.user = user
      localStorage.setItem(UserKey, JSON.stringify(user))
    },

    SET_TOKEN: (state, token) => {
      state.token = token
      Cookies.set(TokenKey, token)
    },

    SET_ROLES: (state, roles) => {
      state.roles = roles
      localStorage.setItem(RoleKey, JSON.stringify(roles))
    }
  },

  actions: {
    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_USER', {})
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        resolve()
      })
    },
  }
}

export default user
